

export default {
  computed: {

    /**
     * Kundnummer, typ 6401027534
     */
    customerCode(){
      if(this._invoice)
        return this._invoice.CustomerCode
    },

    /**
     * Namn, typ "Kalle Anka"
     */
    tenantName(){
      if(this._invoice)
        return this._invoice.TenantName
    },

    /**
     * Addressen för kontraktet
     */
    address(){
      if(this._invoice)
        return this._invoice.Address

    },

    balance(){
      if(this._invoice)
        return this._invoice.Balance
    },

    /**
     * Aviserat belopp, t.ex. 1234
     */
    amount(){
      if(this._invoice)
        return this._invoice.InvoiceAmount
    },

    /**
     * "Hyra bostad"
     */
    caption(){
      if(!this._invoice || this._invoice.InvoiceRows.lenght == 0)
        return;

      return this._invoice.InvoiceRows.reduce((y,i) => y.Caption + ', ' + i.Caption)
    },
    giro(){
      if(this._invoice)
        return this._invoice.GiroLocalPrint
    },
    ocr(){
      if(this._invoice)
        return this._invoice.Ocr
    },

    /**
     * Från datum
     * Tex 2016-07-01T00:00:00
     */
    fromDate(){
      if(this._invoice && this._invoice.FromDate)
        return this._invoice.FromDate.replace(/\s+/g, '')
    },

    /**
     * Från datum
     * Tex 2016-07-01T00:00:00
     */
    toDate(){
      if(this._invoice && this._invoice.ToDate)
        return this._invoice.ToDate.replace(/\s+/g, '')
    },

    /**
     * Inbetalt belopp.
     * Typ 1245
     */
    paidAmount(){
      if(this._invoice)
        return this._invoice.PaidAmount
    },
    /**
     * Referens, typ "3001-002-02-0021.04"
     */
    reference(){
      if(this._invoice)
        return this._invoice.Reference;
    },

    /**
     * Förfallodatum
     * Typ 2018-10-31
     */
    expireDate(){
      if(this._invoice && this._invoice.ExpireDate)
        return this._invoice.ExpireDate
    },

    /**
     * Hur mycket återstår att betala.
     * Typ 2000
     */
    remainingAmount(){
      if(this.paidAmount && this.amount) {
        return this.amount - this.paidAmount
      }
      else {
        return this.amount;
      }
    },

    /**
     * Faktura rader.
     * Typ [{Caption: "3001-002-02-0021 2 ROK Södra Stapeltorgsgatan 7 B", InvoiceRowSum: 0, Quantity: 0,…}]
     */
    invoiceRows(){
      return null;
      if(!this._invoice.InvoiceRows)
        return [];

      return this._invoice.InvoiceRows;
    },

    /**
     * Url till pdf för nedladdning.
     * Typ https://tst-abg-mypages-api.azurewebsites.net/api/invoices/519030000425/pdf?_token=
     */
    pdfLink(){
      if(this._invoice)
        return this._invoice.PdfLink
    }
  }
}
